module.exports = __webpack_public_path__ + "img/LearningFirst_logo.4bc27756.png";